export default "__VITE_ASSET__hr3dW1MU__"